
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/agents",
      function () {
        return require("private-next-pages/customer-studio/agents.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/agents"])
      });
    }
  